import WGCornmealProduct from 'models/WGCornmealProduct'

export const textureOptions = [
  { value: '', label: 'Texture', isDisabled: true },
  { value: 'Coarse', label: 'Coarse' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Fine', label: 'Fine' },
]

export const colorOptions = [
  { value: '', label: 'Color', isDisabled: true },
  { value: 'Yellow', label: 'Yellow' },
  { value: 'White', label: 'White' },
]

export const packagingInitialState = {
  category: WGCornmealProduct.category,
  subCategory: WGCornmealProduct.subCategory,
  Texture: {
    value: textureOptions[0].value,
    label: textureOptions[0].label,
  },
  Color: {
    value: colorOptions[0].value,
    label: colorOptions[0].label,
  },
  Size: WGCornmealProduct.Size,
  WholeGrainCert: WGCornmealProduct.WholeGrainCert,
}
